import { AppBar, styled } from "@mui/material";

export const TopNavigationWrapper = styled(AppBar)(({ theme }) => {
	return {
		position: "static",
		backgroundColor: "var(--primary-color)",
		boxShadow: "none",
		"& .MuiToolbar-root": {
			minHeight: "var(--top-nav-height)",
			backgroundColor: "inherit",
			borderRadius: "inherit",
			padding: "calc(var(--basic-padding)/2) var(--basic-padding)",
			gap: "var(--flex-gap)",
			justifyContent: "space-between",
		},
		"& .top-navigation-LHS": {
			overflow: "hidden",
			display: "none",
			width: "-webkit-fill-available",
		},
		"& .top-navigation-RHS": {
			overflow: "hidden",
		},
		"& .top-navigation-RHS-item": {
			border: "2px solid var(--light-color)",
			borderRadius: "16px",
			padding: "calc(var(--basic-padding)/2)",
			"& .role-box": {
				padding: "calc(var(--basic-padding)/4)",
				backgroundColor: "#EAF1FF",
				borderRadius: "8px",
			},
		},
		"& .menu-button-box": {
			display: "flex",
			justifyContent: "center",
		},
		"& .user-profile-icon-area, & .notification-icon-area": {
			display: "none",
		},
		[theme.breakpoints.up(200)]: {
			"& .top-navigation-LHS": {
				display: "block",
			},
			"& .top-navigation-RHS": {
				overflow: "unset",
				cursor: "pointer",
			},
		},
		[theme.breakpoints.up("tablet")]: {
			width: "auto",
			position: "fixed",
			top: 0,
			right: 0,
			left: "var(--side-nav-width)",
			borderRadius: "16px",
			backgroundColor: "inherit",
			"& .menu-button-box": {
				display: "none",
			},
			"& .user-profile-icon-area": {
				display: "flex",
			},
			"& .notification-icon-area": {
				display: "block",
			},
			"& .MuiToolbar-root": {
				backgroundColor: "var(--primary-color)",
				margin: "var(--basic-margin)",
				marginBottom: 0,
			},
		},
		[theme.breakpoints.between("tablet", "laptop")]: {
			"& .MuiToolbar-root": {
				flexDirection: "column",
				alignItems: "flex-start",
				gap: "calc(var(--flex-gap)/2)",
				padding: "calc(var(--basic-padding)/2) calc(var(--basic-padding)/1.25)",
				paddingBottom: "var(--basic-padding)",
			},
		},
	};
});
